const enAgentDashboardPage = {
  // agent profile
  agentProfilePage_Title: 'Agent profile',
  agentProfilePage_SubTitle: 'Update agent profile',
  agentUserPage_Title: 'Agent users',
  agentUserPage_SubTitle: 'Manage agent users',
  agentUserPage_AddUser: 'Add user',
  agentUserPage_UpdateUser: 'Update agent user',
  agentUserPage_CreateUser: 'Create agent user',
  // agent bookmark
  agentBookmarkHotelPage_Title: 'Bookmark hotels',
  agentBookmarkHotelPage_SubTitle: 'Manage bookmark hotels',
  // booking pages
  agentBookingListPage_PageTitle: 'Bookings',
  agentBookingListPage_PageSubTitle: 'Manage agent bookings',
  agentBookingListPage_OrderId: 'Order ID',
  agentBookingListPage_RefNumber: 'Booking Number',
  agentBookingListPage_AgentBookingRef: 'Agent Booking Ref',
  agentBookingListPage_BookingStatus: 'Booking Status',
  agentBookingListPage_PaymentStatus: 'Payment Status',
  agentBookingListPage_CheckinDate: 'Check-in Date',
  agentBookingListPage_CheckoutDate: 'Check-out Date',
  agentBookingListPage_TotalPrice: 'Total price',
  agentBookingListPage_BookingDate: 'Booking date',
  agentBookingListPage_LeadPassenger: 'Lead passenger',
  agentBookingListPage_HotelName: 'Hotel Name',
  agentBookingListPage_SupplierRefNumbers: 'Supplier Ref',
  agentBookingListPage_BookingDetail: 'Booking detail',
  agentBookingListPage_BookingFrom: 'Booking from',
  agentBookingListPage_BookingTo: 'Booking to',
  agentBookingListPage_CheckinFrom: 'Check-in from',
  agentBookingListPage_CheckinTo: 'Check-in to',
  agentBookingListPage_CheckoutFrom: 'Check-out from',
  agentBookingListPage_CheckoutTo: 'Check-out to',
  agentBookingListPage_CancellationFrom: 'Cancelled from',
  agentBookingListPage_CancellationTo: 'Cancelled to',
  agentBookingListPage_AdvancedSearch: 'Advanced search',
  // order booking
  agentOrderBooking_Title: 'Order bookings',
  agentOrderBooking_PageSubTitle: 'Manage agent order bookings',
  agentOrderBooking_TotalPayment: 'Total payment',
};

export default enAgentDashboardPage;
